import { custom, tuple, number } from '@recoiljs/refine';
import type { Checker } from '@recoiljs/refine';

// Same as stringLiterals but ignores the key values and only checks the values
// useful to test *Values objects generated by Codegen
export function stringLiteralsCodegen<T extends Record<string, string>>(
  enumValues: T
): Checker<T[keyof T]> {
  return custom(
    (value) => {
      if (typeof value !== 'string') {
        return null;
      }

      // Check if the value exists in the object's values
      const isValueValid = Object.values(enumValues).includes(value);

      // In Refine, custom checkers return the value if valid, or null/undefined if invalid
      return isValueValid ? (value as T[keyof T]) : null;
    },
    `value is not one of: ${Object.values(enumValues).join(', ')}`
  );
}

export const vec3Checker = () => tuple(number(), number(), number());
